<template>
  <div class="worktime">
    <el-select
      :value="copyValue.day"
      @change="updateValue($event, 'day')"
      placeholder="День недели"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-time-select
      placeholder="Начало работы"
      :value="copyValue.open"
      @input="updateValue($event, 'open')"
      :picker-options="{
        start: '08:30',
        step: '00:15',
        end: '18:30',
      }"
    >
    </el-time-select>
    <el-time-select
      placeholder="Окончание работы"
      :value="copyValue.close"
      @input="updateValue($event, 'close')"
      :picker-options="{
        start: '08:30',
        step: '00:15',
        end: '18:30',
        minTime: copyValue.open,
      }"
    >
    </el-time-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Object],
      required: false,
      default: () => ({
        day: "",
        open: "",
        close: "",
      }),
    },
  },
  data() {
    return {
      options: [
        {
          value: "MONDAY",
          label: "Понедельник",
        },
        {
          value: "TUESDAY",
          label: "Вторник",
        },
        {
          value: "WEDNESDAY",
          label: "Среда",
        },
        {
          value: "THURSDAY",
          label: "Четверг",
        },
        {
          value: "FRIDAY",
          label: "Пятница",
        },
        {
          value: "SATURDAY",
          label: "Суббота",
        },
        {
          value: "SUNDAY",
          label: "Воскресенье",
        },
      ],
      copyValue: { ...this.value },
    };
  },
  methods: {
    updateValue(value, key) {
      this.copyValue[key] = value;

      if (this.isFieldFilled(this.copyValue)) {
        this.$emit("input", this.copyValue);
      }
    },
    isFieldFilled(obj) {
      for (const key in obj) {
        if (!obj[key]) return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.worktime {
  display: flex;
  column-gap: 15px;
}
</style>
